import storage from "../../utils/storage";
import { intialConfig } from "../axios/axios.config";

const getBasicHeader = () => {
    const creds = storage.getItem("basicLogin") || {}
    const headers = {
        Authtype: "BASIC",
        "x-auth-username": creds?.email,
        "x-auth-password": creds?.password
    }
    return headers
}

export const getDeploymentStatus = async () => {
    try {
        const response = await intialConfig.get(`/status`)
        return response?.result?.status
    } catch (error) {
        console.error(error)
    }
}

export const basicLogin = async (payload) => {
    return await intialConfig.post("users/basic-login", payload, {
        headers: getBasicHeader()
    });
};

export const createAdminUser = async (payload) => {
    try {
        let response = await intialConfig.post("/users", payload, {
            headers: getBasicHeader()
        });
        return {
            ...payload,
            ...response?.data,
            message: response?.data?.result,
            success: true,
        };
    } catch (error) {
        const response = {
            ...payload,
            message: error?.response?.data?.error,
            success: false
        };
        return response;
    }
};

export const deleteAdmin = async () => {
    try {
        let response = await intialConfig.delete("/users/delete-default-admin", {
            headers: getBasicHeader()
        });
        return {
            ...response,
            message: response?.data?.result,
            success: true
        };
    } catch (error) {
        return {
            message: error?.response?.data?.error,
            success: false
        };
    }
};
